<template>
  <div>
    <b-modal id="addAppointmentModalX" size="lg" title="Add Appointment">
      <div class="row mb-3">
        <div class="col-6 d-flex flex-column">
          <label class="h5">Outlet</label>
          <multiselect
            v-model="appointmentForm.outlet"
            label="text"
            track-by="id"
            :options="outlets"
            placeholder="Select Outlet"
            :searchable="true"
            :show-labels="false"
            :allow-empty="false"
            openDirection="below"
            @select="outletSelect"
            class="w-100"
          >
            <template slot="option" slot-scope="{ option }">{{
              option.text
            }}</template>
            <span slot="noResult">{{
              $t("table.no_records")
            }}</span></multiselect
          >
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <div class="d-flex flex-column">
            <label class="h5">Mobile</label>
            <multiselect
              v-model="appointmentForm.member"
              placeholder="Select/Create member"
              tag-placeholder="Enter to create new member"
              label="mobile"
              track-by="mobile"
              :options="members"
              :multiple="false"
              :taggable="true"
              :allow-empty="false"
              selectLabel=""
              selectedLabel=""
              :custom-label="mobileWithName"
              @tag="addMember"
            >
            <template slot="singleLabel" slot-scope="{ option }">
                {{ option.mobile }}
              </template></multiselect>
              <span class="text-danger" v-show="maxCharLimit">
                8 digit max. (exclude country code)
              </span>
            <!-- <multiselect
              v-model="appointmentForm.member"
              placeholder="Select/Create member"
              label="mobile"
              track-by="memberID"
              :taggable="true"
              @tag="addMember"
              :multiple="false"
              :tag-placeholder="'Enter to create member'"
              :options="members"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
              selectLabel=""
              selectedLabel=""
              @select="selectMember"
              :custom-label="mobileWithName"
              openDirection="below"
              class="w-100"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.mobile }}
              </template>
              <template slot="option" slot-scope="{ option }"
                >{{ option.mobile }} {{ option.name }}</template
              >
              <span slot="noResult">{{
                $t("table.no_records")
              }}</span></multiselect
            > -->
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex flex-column">
            <label class="h5">Name</label>
            <b-form-input :placeholder="addFlag ? 'Enter New Member Name':''" v-model="appointmentForm.member.name"></b-form-input>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <label class="h5">Staff</label>
          <b-overlay :show="staffSpinner" rounded="sm">
            <b-input-group>
              <b-form-input
                type="search"
                @input="searchStaff"
                v-model="searchThatStaff"
                placeholder="Search Staff"
              ></b-form-input>
            </b-input-group>

            <div
              class="w-100 p-2 d-flex flex-row"
              style="height: 80px; overflow-x: scroll"
            >
              <b-button
                v-for="(s, index) in staffs"
                :key="index"
                class="text-truncate btn-staff mr-1"
                style="min-width: 120px; max-width: 150px"
                size="xs"
                :class="appointmentForm.staff === s ? 'active' : ''"
                @click="(appointmentForm.staff = s), (searchThatStaff = s.name), appointmentForm.duration = null,staffAvailability(appointmentForm.arrivalDate)"
                ><b-avatar
                  :src="s.image != '' ? s.image : s.icon"
                  size="2rem"
                  class="mx-1"
                ></b-avatar
                >{{ s.name }}</b-button
              >
            </div>
          </b-overlay>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <label class="h5">Date</label>
          <!-- <b-form-input :disabled="appointmentForm.staff == null" v-model="appointmentForm.arrivalDate" @input="staffAvailability" :min="minDate" type="date"></b-form-input> -->
          <b-form-datepicker
            :disabled="appointmentForm.staff == null"
            id="appointment-datepicker"
            :min="minDate"
            v-model="appointmentForm.arrivalDate"
            @input="staffAvailability"
            class="mb-2"
          ></b-form-datepicker>
        </div>
        <div class="col-6">
          <label class="h5">Time</label>
          <b-overlay :show="timeSpinner"
            ><b-form-select
              :disabled="appointmentForm.arrivalDate == null"
              v-model="appointmentForm.time"
              :options="timeOptions.length === 0 ? timeOptionsClone:timeOptions"
            ></b-form-select
          ></b-overlay>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <label class="h5">Service</label>
          <multiselect
            v-model="appointmentForm.sku"
            placeholder="Select Service"
            label="name"
            track-by="skuID"
            :multiple="false"
            :options="skuList"
            :searchable="true"
            :show-labels="false"
            :allow-empty="false"
            @select="skuSelect"
            openDirection="below"
            class="w-100"
          >
            <template slot="option" slot-scope="{ option }">{{
              option.name
            }}</template>
            <span slot="noResult">{{
              $t("table.no_records")
            }}</span></multiselect
          >
        </div>
        <div class="col-6">
          <label class="h5">Duration</label>
          <b-form-select v-model="appointmentForm.duration">
            <b-form-select-option :value="null" disabled
              >Select Duration</b-form-select-option
            >
            <b-form-select-option
              v-for="(d, index) in durationList"
              :key="index"
              :value="d"
              >{{ d.text }}</b-form-select-option
            >
          </b-form-select>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6 d-flex flex-column">
          <label class="h5">Color</label>
          <div>
            <button
              size="sm"
              id="popover-color-list"
              class="btn rounded-pill"
              :class="
                appointmentForm.color.color == 'white'
                  ? 'text-dark'
                  : 'text-light'
              "
              :style="`background-color:${appointmentForm.color.hex};border-color:${appointmentForm.color.hex};`"
            >
              {{ appointmentForm.color.color }}
            </button>
            <b-popover
              target="popover-color-list"
              triggers="click"
              placement="top"
            >
              <div class="d-flex p-2" style="overflow-x: scroll">
                <a
                  v-for="(c, index) in colorList"
                  @click="(appointmentForm.color = c), closePop()"
                  :key="index"
                  :style="`background-color:${c.hex}`"
                  class="boxColor link m-2"
                  >{{ c.color }}</a
                >
              </div>
            </b-popover>
          </div>
        </div>
        <div class="col-6">
          <label class="h5">Block Time</label>
          <b-form-checkbox
            v-model="appointmentForm.blocked"
            switch
            size="lg"
          ></b-form-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label class="h5">Remarks</label>
          <textarea
            v-model="appointmentForm.remarks"
            class="form-control"
            cols="1"
            rows="5"
          ></textarea>
        </div>
      </div>
      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <div class="d-flex">
            <b-button @click="close()">Close</b-button>
            <b-button
              v-b-modal.appointmentSummaryModal
              class="ml-1"
              :disabled="saveable"
              variant="primary"
              >Save</b-button
            >
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal id="appointmentSummaryModal" title="Appointment Summary" size="sm">
      <template #modal-header>
        <div class="d-flex w-100 justify-content-center h2 text-primary">
          Appointment Summary
        </div>
      </template>
      <div class="d-flex flex-column w-100">
        <div class="d-flex flex-column mb-3">
          <label>Outlet</label>
          <b>{{
            appointmentForm.outlet != null
              ? appointmentForm.outlet.bizName
              : "-"
          }}</b>
        </div>
        <div class="d-flex flex-column mb-3">
          <label>Member Info</label>
          <b
            >{{
              appointmentForm.member != null
                ? appointmentForm.member.mobile
                : "-"
            }}
            ({{
              appointmentForm.member != null ? appointmentForm.member.name : ""
            }})</b
          >
        </div>
        <div class="d-flex flex-column mb-3">
          <label>Date & Time</label>
          <b>{{ combineDateTime }}</b>
        </div>
        <div class="d-flex flex-column mb-3">
          <label>Staff</label>
          <b>{{
            appointmentForm.staff != null ? appointmentForm.staff.name : "-"
          }}</b>
        </div>
        <div class="d-flex flex-column mb-3">
          <label>Service & Duration</label>
          <b
            >{{
              appointmentForm.sku != null ? appointmentForm.sku.name : "-"
            }}
            ({{
              appointmentForm.duration != null
                ? appointmentForm.duration.text
                : ""
            }})</b
          >
        </div>
        <div class="d-flex flex-column mb-3">
          <label>Remarks</label>
          <b>{{
            appointmentForm.remarks === "" ? "-" : appointmentForm.remarks
          }}</b>
        </div>
      </div>
      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-center">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="createAppt()">OK</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import {
  handleSessionExpired,
  idbOpen,
  toastrExe,
} from "../../../../assets/js/dashboard/dashboard";
import { vMaska } from "maska";
import moment from "moment";
export default {
  name: "AddAppointmentModal",
  props: {
    sku: Array,
    selected: Object,
    selectedDate:Date,
    selectedStaff:Number
  },
  directives: { maska: vMaska },
  watch: {
    sku() {
      this.skuList = this.$props.sku;
    },
    selected() {
      console.log("outlet change modalX")
      this.appointmentForm.outlet = this.$props.selected;
      this.outletSelect(this.appointmentForm.outlet);
    },
    selectedDate(){
      this.staffAvailability(moment(this.$props.selectedDate).format("YYYY-MM-DD"));
      this.appointmentForm.time = moment(this.$props.selectedDate).format("HH:mm");
    },
    selectedStaff(){
      if(this.$props.selectedStaff !== 0)
      this.appointmentForm.staff = this.staffs.find(s => s.staffID == this.$props.selectedStaff);
      else
      this.appointmentForm.staff = this.staffs[0];

      this.searchThatStaff = this.appointmentForm.staff.name;
      this.staffAvailability(moment(this.$props.selectedDate).format("YYYY-MM-DD"));
      this.appointmentForm.time = moment(this.$props.selectedDate).format("HH:mm");
    }
  },
  data() {
    return {
      appointmentForm: {
        outlet: null,
        arrivalDate: null,
        time: null,
        staff: null,
        member: {
          name: "",
          mobile: "",
        },
        sku: null,
        color: {
          hex: "",
          color: "",
        },
        blocked: false,
        duration: null,
        remarks: "",
      },
      outlets: [],
      timeSlots: [],
      staffs: [],
      staffsClone: [],
      staffsOutletClone: [],
      skuList: [],
      colorList: [],
      bookHours: [],
      toggle: false,
      db: null,
      members: [],
      addFlag: false,
      staffSpinner: false,
      timeSpinner: false,
      maxCharLimit:false,
      searchThatStaff: "",
    };
  },
  methods: {
    closePop() {
      this.$root.$emit("bv::hide::popover", "popover-color-list");
    },
    clearForm() {
      this.appointmentForm = {
        outlet: this.appointmentForm.outlet,
        arrivalDate: null,
        time: null,
        staff: null,
        member: {
          name: "",
          mobile: "",
        },
        sku: null,
        color:this.colorList[0],
        blocked: false,
        duration: null,
        remarks: "",
      };
    },
    skuSelect(event) {
      this.appointmentForm.sku = event;
      let index = this.durationList.find((v) => v.value == event.duration);
      this.appointmentForm.duration = index;
    },
    selectDate(event, type) {
      if (type === 1) {
        this.appointmentForm.arrivalDate = event;
      } else {
        this.appointmentForm.time = event;
      }

      this.staffs.slice(0, this.staffs.length, ...this.staffsOutletClone);
      this.staffs = JSON.parse(JSON.stringify(this.staffsOutletClone));
      this.staffSpinner = true;
      var bar = new Promise((resolve, reject) => {
        this.staffs.forEach(async (value, index, array) => {
          await this.staffAvailability(index, value);
          if (index === array.length - 1 || index >= array.length) resolve();
        });
      });
      bar.then(() => {
        this.staffSpinner = false;
      });
    },
    async addMember(event) {
      this.addFlag = true;
      if(event.charAt(0) != "6"){
        event = "6"+event;
      }
      if(event.charAt(0) == '6' && event.charAt(1) == '0'){
        if(event.length > 12){
          this.maxCharLimit = true;
        }
        else{
          this.maxCharLimit = false;
        }
      }
      else if(event.charAt(0) == '6' && event.charAt(1) == '5'){
        if(event.length > 10){
          this.maxCharLimit = true;
        }
         else{
          this.maxCharLimit = false;
        }
      }
      if(!this.maxCharLimit){
        this.appointmentForm.member = {
        mobile: event,
        name: "",
      };
      this.members.push({
        mobile: event,
        name: this.appointmentForm.member.name === '' ? this.appointmentForm.member.mobile:this.appointmentForm.member.name,
      });
      }
    },
    selectMember(event) {
      this.addFlag = false;
      this.appointmentForm.member = event;
    },
    async staffAvailability(event) {
      console.log("staff avail")
      if(event === null){
        return;
      }
      console.log(this.appointmentForm.staff)
      this.timeSpinner = true;
      this.appointmentForm.arrivalDate = event;
      this.timeSlots = [];
      let $vm = this;
      let result = [];
      let leFormattedDate = moment($vm.appointmentForm.arrivalDate).format(
        "DD-MM-YYYY"
      );
      let url =
        $vm.$api.STAFF +
        "/" +
        $vm.appointmentForm.staff.staffID +
        "/slots/" +
        leFormattedDate;
      await $vm
        .$axios({
          method: "get",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_BEBUSINESS,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response.data.slots;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      result.forEach((element) => {
        element.slotDate = moment(new Date(element.slotDate * 1000))
          .subtract(8, "hours")
          .toDate();
        let hours =
          element.slotDate.getHours() < 10
            ? "0" + element.slotDate.getHours().toString()
            : element.slotDate.getHours();
        let minutes =
          element.slotDate.getMinutes() === 0
            ? "00"
            : element.slotDate.getMinutes();
        let formattedTime = `${hours}:${minutes}`;
        if (element.blockDate === 0) {
          this.timeSlots.push(formattedTime);
        }
      });
      this.timeSpinner = false;
    },
    disabledTimeSlot(val) {
      let gvf = this.timeSlots.find((i) => i == val);
      if (gvf === undefined || gvf === null) {
        return false;
      } else {
        return true;
      }
    },
    // async staffAvailability(index, event) {
    //   let $vm = this;
    //   let result = [];
    //   let leFormattedDate = moment(this.appointmentForm.arrivalDate).format(
    //     "DD-MM-YYYY"
    //   );
    //   let url =
    //     this.$api.STAFF + "/" + event.staffID + "/slots/" + leFormattedDate;
    //   await $vm
    //     .$axios({
    //       method: "get",
    //       url: url,
    //       baseURL: $vm.$api.API_ENDPOINT_BEBUSINESS,
    //       headers: { token: $vm.$session.get("token") },
    //     })
    //     .then(function (response) {
    //       result = response;
    //     })
    //     .catch((err) => {
    //       result = err.response;
    //       var errData = err.response.data;
    //       if (errData.error == $vm.$api.INVALID_TOKEN) {
    //         handleSessionExpired();
    //       }
    //     });
    //   if (result.status !== 200) {
    //     return;
    //   }
    //   result.data.slots.forEach((element) => {
    //       element.slotDate = moment(new Date(element.slotDate * 1000))
    //         .subtract(8, "hours")
    //         .toDate();
    //       let hours =
    //         element.slotDate.getHours() < 10
    //           ? "0" + element.slotDate.getHours().toString()
    //           : element.slotDate.getHours();
    //       let minutes =
    //         element.slotDate.getMinutes() === 0
    //           ? "00"
    //           : element.slotDate.getMinutes();
    //       let formattedTime = `${hours}:${minutes}`;
    //       if (formattedTime == this.appointmentForm.time) {
    //         if (element.blockDate != 0) {
    //           this.staffs.splice(index, 1);
    //         }
    //       }
    //   });
    // },
    mobileWithName({ mobile, name }) {
      return `${mobile} — ${name === '' ? mobile:name}`;
    },
    async outletSelect(sel) {
      this.appointmentForm.staff = null;
      this.staffs = this.staffsClone.filter((s) => {
        if (s.outletID == sel.id && s.showOnline === 1 && s.showAppt === 1 && s.enable === 1) {
          return s;
        }
      });
      this.timeSpinner = true;
      this.staffsOutletClone = JSON.parse(JSON.stringify(this.staffs));
      let url = `https://bebusiness.tunai.io/outlet/${sel.id}/bookhour`;
      let result = [];
      await this.$axios({
        method: "get",
        url: url,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data.hours;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.bookHours = result;
      this.timeSpinner = false;
    },
    mutateDuration(num) {
      this.appointmentForm.duration =
        Number(this.appointmentForm.duration) + num;
    },
    async getStaffList() {
      let st = await this.$store.state.staffs;
      this.staffs = JSON.parse(st);
      console.log(this.staffs)
      this.staffs = this.staffs.filter(s=>s.outletID == this.outlets[0].id && s.showOnline === 1 && s.showAppt === 1 && s.enable === 1);
      this.staffsClone = JSON.parse(st);
    },
    async getSKUList() {
      let url = "/business/appt";
      let $vm = this;
      let result = [];
      await this.$axios({
        method: "get",
        url: url,
        baseURL: this.$api.API_ENDPOINT_MENU,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      this.skuList = result.skus;
    },
    async getColorList() {
      let url = "/colors";
      let result = [];
      await this.$axios({
        method: "get",
        url: url,
        baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data.colors;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      this.colorList = result;
      this.appointmentForm.color = this.colorList[0];
    },
    async getMemberData() {
      const tx = this.db.transaction("member_list", "readwrite");
      const store = tx.objectStore("member_list");
      let res = await store.get("key");
      res = res.filter((val) => val.deleteDate == 0);
      return res;
    },
    searchStaff(val) {
      this.staffs = this.staffsOutletClone.filter((s) => {
        if (s.name.toUpperCase().includes(val.toUpperCase())) {
          return s;
        }
      });
    },
    formatDate(date, format) {
      let formattedDate = moment(date).format(format);
      if (formattedDate == "Invalid date") {
        return "-";
      } else {
        return formattedDate;
      }
    },
    async createAppt() {
      let $vm = this;
      let combinedDate =
        this.appointmentForm.arrivalDate + " " + this.appointmentForm.time;
      let formattedDate = moment(combinedDate).toDate();
      formattedDate = formattedDate.getTime() / 1000;
      let mbl = this.appointmentForm.member.mobile.charAt(0);
      if (mbl != "6") {
        toastrExe($vm, "New Member", `Number must start with 6 or 65.`, "danger");
        return;
      }
      let url = "https://member.tunai.io/business/member";
      let result = [];
      if (this.addFlag) {
        await this.$axios({
          method: "post",
          url: url,
          headers: { token: this.$session.get("token") },
          data: {
            name: $vm.appointmentForm.member.name,
            mobile: $vm.appointmentForm.member.mobile,
            outletID: $vm.appointmentForm.outlet.id,
          },
        })
          .then(function (response) {
            result = response;
          })
          .catch((err) => {
            result = err.response;
            var errData = err.response.data;
            if (errData.error == this.$api.INVALID_TOKEN) {
              handleSessionExpired();
            }
          });
        if (result.status === 200) {
          toastrExe(
            $vm,
            "New Member",
            `Successfully created member ${$vm.appointmentForm.member.name}`,
            "success"
          );
          this.appointmentForm.member.memberID =
            result.data.members[0].memberID;
        } else {
          toastrExe(
            $vm,
            "New Member",
            `Failed to created member ${$vm.appointmentForm.member.name}`,
            "danger"
          );
        }
      }
      url = "https://appt.tunai.io/business/book";
      await this.$axios({
        method: "post",
        url: url,
        headers: { token: this.$session.get("token") },
        data: {
          memberID: $vm.appointmentForm.member.memberID,
          outletID: $vm.appointmentForm.outlet.id,
          skuID: $vm.appointmentForm.sku.skuID,
          duration: Number($vm.appointmentForm.duration.value),
          colorID: $vm.appointmentForm.color.colorID,
          blocked: $vm.appointmentForm.blocked ? 1 : 0,
          arrivalDate: formattedDate,
          staffID: $vm.appointmentForm.staff.staffID,
          remarks: $vm.appointmentForm.remarks,
        },
      })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      if (result.status === 200) {
        // toastrExe(
        //   $vm,
        //   "New Appointment",
        //   `Successfully created appointment for ${$vm.appointmentForm.member.name}`,
        //   "success"
        // );
        Swal.fire({
          icon: "success",
          title: "Add Appointment",
          text: `Successfully created appointment for ${$vm.appointmentForm.member.name}`,
        });
        this.$emit("apptCreated", result.data.books[0]);
        this.$bvModal.hide("addAppointmentModalX");
        this.$bvModal.hide("appointmentSummaryModal");
        this.clearForm();
      } else {
        toastrExe(
          $vm,
          "New Appointment",
          `Failed to created appointment for ${$vm.appointmentForm.member.name}`,
          "danger"
        );
        this.$bvModal.hide("appointmentSummaryModal");
      }
    },
  },
  async created() {
    this.outlets = JSON.parse(await this.$store.state.outlets);
    this.appointmentForm.outlet = this.outlets[0];
    let dbName = this.$store.state.userName + "_memberList";
    this.db = await idbOpen(dbName, "member_list");
    this.members = await this.getMemberData();
    await this.getColorList();
    await this.getSKUList();
    await this.getStaffList();
  },
  computed: {
    minDate() {
      let now = moment().format("YYYY-MM-DD");
      return now;
    },
    combineDateTime() {
      let combinedDate =
        this.appointmentForm.arrivalDate + " " + this.appointmentForm.time;
      let formattedDate = moment(combinedDate).format("DD MMM YYYY hh:mm a");
      return formattedDate;
    },
    timeOptions() {
      let quarterHours = ["00", "15", "30", "45"];
      let times = [];
      for (let i = 0; i < 24; i++) {
        if (this.bookHours.length > 0 && this.bookHours[i].appt != 0) {
          for (let j = 0; j < 4; j++) {
            let fts = (i < 10 ? "0" + i.toString() : i) + ":" + quarterHours[j];
            let gvf = this.timeSlots.find((ts) => ts === fts);
            if (gvf !== undefined) times.push(fts);
          }
        }
      }
      return times;
    },
    timeOptionsClone() {
      let quarterHours = ["00", "15", "30", "45"];
      let times = [];
      for (let i = 0; i < 24; i++) {
        if (this.bookHours.length > 0 && this.bookHours[i].appt != 0) {
          for (let j = 0; j < 4; j++) {
            let fts = (i < 10 ? "0" + i.toString() : i) + ":" + quarterHours[j];
             times.push(fts);
          }
        }
      }
      return times;
    },
    durationList() {
      return [
        { value: 15, text: "15 Minutes" },
        { value: 30, text: "30 Minutes" },
        { value: 45, text: "45 Minutes" },
        { value: 60, text: "1 Hour" },
        { value: 75, text: "1 Hour 15 Minutes" },
        { value: 90, text: "1 Hour 30 Minutes" },
        { value: 105, text: "1 Hour 45 Minutes" },
        { value: 120, text: "2 Hours" },
        { value: 135, text: "2 Hours 15 Minutes" },
        { value: 150, text: "2 Hours 30 Minutes" },
        { value: 165, text: "2 Hours 45 Minutes" },
        { value: 180, text: "3 Hours" },
        { value: 195, text: "3 Hours 15 Minutes" },
        { value: 210, text: "3 Hours 30 Minutes" },
        { value: 225, text: "3 Hours 45 Minutes" },
        { value: 240, text: "4 Hours" },
      ];
    },
    saveable() {
      let form = this.appointmentForm;
      let flag = false;
      if (
        form.member.mobile === "" ||
        form.member.name === "" ||
        form.arrivalDate === null ||
        form.time === null ||
        form.staff === null ||
        form.sku === null ||
        form.duration === null ||
        form.color === null
      ) {
        flag = true;
      }
      return flag;
    },
  },
};
</script>
<style>
#addAppointmentModalX___BV_modal_content_ {
  border-radius: 0.7rem;
}
.btn-staff {
  color: black !important;
  background-color: #eaebeb !important;
  border-color: #eaebeb !important;
  box-shadow: none !important;
}
.btn-staff.active {
  color: white !important;
  background-color: #886ab5 !important;
  border-color: #886ab5 !important;
}
.btn-staff:hover {
  color: white !important;
  background-color: #886ab5 !important;
  border-color: #886ab5 !important;
}
.boxColor {
  height: 40px;
  min-width: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white !important;
}
.popover-body {
  padding: 0 !important;
}
.b-popover {
  max-width: 700px !important;
}
#appointment-datepicker__dialog_ {
  display: none !important;
}
#appointment-datepicker__dialog_.show {
  display: block !important;
}
</style>